export { default } from './TabBar';
export type { TabDefinition } from './Tab';
